import { ProceduresService } from "@/common/api.service";
import { FETCH_PROCEDURE_DATA, FETCH_INDIVIDUAL_PROCEDURE_DATA, FETCH_PROCEDURE_CATEGORY, RESET_STATE } from "./actions.type";
import { SET_PROCEDURE_DATA, SET_INDIVIDUAL_PROCEDURE_DATA, SET_PROCEDURE_ERROR, SET_PROCEDURE_CATEGORY, STATE_RESET } from "./mutations.type";


const initialState = () => {
  return {
    proceduredata: [],
    individualproceduredata: [],
    procedureerror: [],
    procedurecategorylist:[]
  }
};

export const state = initialState();

const actions = {

  async [FETCH_PROCEDURE_DATA](context, slug) {
    return await ProceduresService.get(slug).then((response) => {
      context.commit(SET_PROCEDURE_DATA, response.data)
      return response
    }).catch(({ response }) => {
      context.commit(SET_PROCEDURE_ERROR, response.data.errorMessage)
      return response
    })
  },

  async [FETCH_INDIVIDUAL_PROCEDURE_DATA](context, slug) {
    return await ProceduresService.get(slug).then((response) => {
      context.commit(SET_INDIVIDUAL_PROCEDURE_DATA, response.data)
      return response
    }).catch(({ response }) => {
      context.commit(SET_PROCEDURE_ERROR, response.data.errorMessage)
      return response
    })
  },

  async [FETCH_PROCEDURE_CATEGORY](context, slug) {
    return await ProceduresService.get(slug).then((response) => {
      context.commit(SET_PROCEDURE_CATEGORY, response.data)
      return response
    }).catch(({ response }) => {
      context.commit(SET_PROCEDURE_ERROR, response.data.errorMessage)
      return response
    })
  },

  [RESET_STATE]({ commit }) {
    commit(STATE_RESET)
  }

}

const mutations = {

  [SET_PROCEDURE_DATA](state, proceduredata) {
    state.proceduredata = proceduredata
  },
  [SET_INDIVIDUAL_PROCEDURE_DATA](state, individualproceduredata) {
    state.individualproceduredata = individualproceduredata
  },
  [SET_PROCEDURE_CATEGORY](state, procedurecategorylist) {
    state.procedurecategorylist = procedurecategorylist
  },
  [SET_PROCEDURE_ERROR](state, error) {
    state.procedureerror = error
  },
  [STATE_RESET](state) {
    Object.assign(state, initialState())
  }

}

const getters = {

  proceduredata(state) {
    return state.proceduredata;
  },
  individualproceduredata(state) {
    return state.individualproceduredata;
  },
  procedurecategorylist(state) {
    return state.procedurecategorylist;
  }

}

export default {
  state,
  getters,
  actions,
  mutations
};